import React from 'react'
import styled from '@emotion/styled'

import HotelPlaceholder from './HotelPlaceholder'
import RoomPlaceholder from './RoomPlaceholder'

export type ImagePlaceholderType = 'hotel' | 'room'

interface Props {
  type?: ImagePlaceholderType
}

const Wrapper = styled.div`
  position: absolute;
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
  svg {
    width: 100%;
    height: 100%;
  }
`

export const ImagePlaceholder = ({type = 'hotel'}: Props) => {
  return (
    <Wrapper>
      {type === 'room' ? <RoomPlaceholder /> : <HotelPlaceholder />}
    </Wrapper>
  )
}
